/**
 * Abra Bundle Components Loader
 */

class AbraBundleLoader {
  constructor() {
    this.storefrontToken = '95010296868f42e6d96d3a09c5ad3cb7';
    this.cache = new Map();
    this.lastItemCount = 0; 
    this.skeletonTimeout = null; 
    this.collectionsCache = null;
    this.collectionsCacheTime = 0;
    this.collectionsCacheTTL = 5000; 
    console.log('[AbraBundle] Initialized with GraphQL token');
  }

  async init() {
    console.log('[AbraBundle] Initializing...');
    
    if (this.lastItemCount === 0) {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        this.lastItemCount = cart.items?.length || 0;
        console.log('[AbraBundle] Initial item count:', this.lastItemCount);
      } catch (e) {
        console.error('[AbraBundle] Error getting initial cart:', e);
      }
    }
    
    const bundleElements = document.querySelectorAll('[data-is-abra-bundle="true"]');
    console.log('[AbraBundle] Found bundles:', bundleElements.length);
    
    if (bundleElements.length === 0) return;

    for (const bundleEl of bundleElements) {
      await this.processBundle(bundleEl);
    }
  }

  /**
   
   */
  getActiveBxgyPromotions() {
    const discounts = window.Abra?.publicPromotion?.discounts;
    if (!discounts) return [];
    
    return Object.values(discounts).filter(d => 
      d.status === 'ACTIVE' && 
      d.discountValue?.type === 'BxgyDiscount'
    );
  }

  /**

   */
  async getBundleProductCards() {
    const promotions = this.getActiveBxgyPromotions();
    console.log('[AbraBundle] Active Bxgy promotions:', promotions.map(p => p.slug));
    
    if (promotions.length === 0) {
      console.log('[AbraBundle] No active Bxgy promotions');
      return null;
    }
    
    const promo = promotions[0];
    console.log('[AbraBundle] Using promotion:', promo.slug);
    console.log('[AbraBundle] Product cards:', promo.discountValue.productCards);
    
    return {
      promotion: promo,
      productCards: promo.discountValue.productCards || []
    };
  }

  /**
 
   */
  async hasBundleEligibleItems() {
    console.log('[AbraBundle] ========== CHECKING ELIGIBILITY ==========');
    
    const bundleConfig = await this.getBundleProductCards();
    if (!bundleConfig || bundleConfig.productCards.length === 0) {
      console.log('[AbraBundle] No bundle configuration found');
      return false;
    }
    
    const { promotion, productCards } = bundleConfig;
    
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      
      if (!cart.items || cart.items.length === 0) {
        return false;
      }
      
      const cartVariantIds = cart.items.map(item => String(item.variant_id));
      console.log('[AbraBundle] Cart variant IDs:', cartVariantIds);
      
      const matchedCards = [];
      
      for (const card of productCards) {
        console.log('[AbraBundle] Checking productCard:', card);
        
       
        let matched = false;
        
        if (card.variantIds && card.variantIds.length > 0) {
          const cardVariantIds = card.variantIds.map(id => String(id));
          const hasMatch = cartVariantIds.some(id => cardVariantIds.includes(id));
          if (hasMatch) {
            matched = true;
            console.log('[AbraBundle] ✓ Card matched by variantIds');
          }
        }
        
        if (!matched && card.productIds && card.productIds.length > 0) {
          const cartProductIds = cart.items.map(i => String(i.product_id));
          const cardProductIds = card.productIds.map(id => String(id));
          const hasMatch = cartProductIds.some(id => cardProductIds.includes(id));
          if (hasMatch) {
            matched = true;
            console.log('[AbraBundle] ✓ Card matched by productIds');
          }
        }
        
        if (!matched && card.productSelections) {
          console.log('[AbraBundle] productSelections found, needs additional check');
        }
        
        if (matched) {
          matchedCards.push(card);
        }
      }
      
      console.log(`[AbraBundle] Matched ${matchedCards.length}/${productCards.length} product cards`);
      
      const requiredMatches = promotion.discountValue.requirementSubquantity || productCards.length;
      const isEligible = matchedCards.length >= requiredMatches;
      
      console.log(`[AbraBundle] Required: ${requiredMatches}, Matched: ${matchedCards.length}, Eligible: ${isEligible}`);
      
      return isEligible;
      
    } catch (error) {
      console.error('[AbraBundle] Error checking eligibility:', error);
      return false;
    }
  }
  /**
  
   */
  async hasAllBundleCollections() {
    console.log('[AbraBundle] Checking if all bundle collections present...');
    const now = Date.now();
    
    if (this.collectionsCache && (now - this.collectionsCacheTime) < this.collectionsCacheTTL) {
      console.log('[AbraBundle] Using cached collections');
      return this.collectionsCache;
    }
    const requiredCollections = [
      'headwear',           
      'mens-party-shirts',  
      'mens-flannels',     
      'mens-bamboo-button-ups'  
    ];
    
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      
      if (!cart.items || cart.items.length < 4) {
        console.log('[AbraBundle] Not enough items (< 4)');
        return false;
      }
      
      const variantIds = cart.items.map(item => item.variant_id);
      
      const query = `
        query {
          nodes(ids: ${JSON.stringify(variantIds.map(id => `gid://shopify/ProductVariant/${id}`))}) {
            ... on ProductVariant {
              id
              product {
                collections(first: 20) {
                  nodes {
                    handle
                  }
                }
              }
            }
          }
        }
      `;
      
      const response = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.storefrontToken
        },
        body: JSON.stringify({ query })
      });
      
      const data = await response.json();
      
      if (data.errors) {
        console.error('[AbraBundle] GraphQL error:', data.errors);
        return false;
      }
      
      const cartCollections = new Set();
      data.data?.nodes?.forEach(node => {
        node?.product?.collections?.nodes?.forEach(collection => {
          cartCollections.add(collection.handle);
        });
      });
      
      console.log('[AbraBundle] Cart collections:', Array.from(cartCollections));
      console.log('[AbraBundle] Required collections:', requiredCollections);
      
      const hasAll = requiredCollections.every(required => 
        cartCollections.has(required)
      );
      
      console.log('[AbraBundle] Has all required collections:', hasAll);
      
    this.collectionsCache = hasAll;
    this.collectionsCacheTime = now;
    
    return hasAll;
      
    } catch (error) {
      console.error('[AbraBundle] Error checking collections:', error);
      return false;
    }
  }
  async processBundle(bundleEl) {
    console.log('[AbraBundle] ========== PROCESS BUNDLE ==========');
    console.log('[AbraBundle] Removing overlay before processing bundle...');
    this.removeBundleSkeleton();
    
    const bundleDataStr = bundleEl.getAttribute('data-bundle-data');
    if (!bundleDataStr) return;

    try {
      const bundleData = JSON.parse(bundleDataStr);
      const components = bundleData.components || [];
      
      if (components.length === 0) return;

      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      let bundleConfig = null;
      if (cart.attributes._abra_bxgy_bundle) {
        try {
          const bxgyBundle = JSON.parse(cart.attributes._abra_bxgy_bundle);
          if (Array.isArray(bxgyBundle) && bxgyBundle.length > 0) {
            bundleConfig = bxgyBundle[0];
            console.log('[AbraBundle] Bundle config:', bundleConfig);
          }
        } catch (e) {
          console.error('[AbraBundle] Error parsing _abra_bxgy_bundle:', e);
        }
      }

      const titleEl = bundleEl.querySelector('[data-bundle-title]');
      if (titleEl) {
        const bundleTitle = bundleConfig?.bundleTitle || bundleData.discountTitle || 'Bundle';
        titleEl.textContent = bundleTitle;
      }

      const collageEl = bundleEl.querySelector('[data-bundle-collage]');
      if (collageEl) {
        if (bundleConfig?.imageUrl) {
          console.log('[AbraBundle] Setting bundle image:', bundleConfig.imageUrl);
          collageEl.innerHTML = `
            <div class="cart-item__bundle-image">
              <img src="${bundleConfig.imageUrl}" alt="${bundleConfig?.bundleTitle || 'Bundle'}" loading="lazy">
            </div>
          `;
        } else {
          console.log('[AbraBundle] No bundle image, will show collage');
        }
      }

      const variantsContainer = bundleEl.querySelector('[data-bundle-variants]');
      if (!variantsContainer) return;

      variantsContainer.innerHTML = '<div class="cart-item__bundle-variants__loading">Loading bundle items...</div>';

      const componentData = await this.fetchComponentsData(components);
      
      this.updateBundlePrice(bundleEl, componentData, bundleData.fixedPriceCents / 100);
      
      console.log('[AbraBundle]', componentData);
      this.renderComponents(variantsContainer, componentData);
      console.log('[AbraBundle] ========== END ==========');
      
    } catch (error) {
      console.error('[AbraBundle] Error:', error);
      const variantsContainer = bundleEl.querySelector('[data-bundle-variants]');
      if (variantsContainer) {
        variantsContainer.innerHTML = `<div class="cart-item__bundle-variants__error">Error: ${error.message}</div>`;
      }
    }
  }
  updateBundlePrice(bundleEl, components, bundleFixedPrice) {
    const priceContainer = bundleEl.querySelector('[data-bundle-price]');
    if (!priceContainer) return;

    const finalPriceEl = priceContainer.querySelector('[data-bundle-final-price]');
    const originalPriceEl = priceContainer.querySelector('[data-bundle-original-price]');
    
    if (!finalPriceEl || !originalPriceEl) return;

    let totalOriginalPrice = 0;
    for (const component of components) {
      totalOriginalPrice += component.price / 100;
    }

    const formattedBundlePrice = bundleFixedPrice.toFixed(2);
    const formattedOriginalPrice = totalOriginalPrice.toFixed(2);
    
    finalPriceEl.textContent = `$${formattedBundlePrice}`;
    originalPriceEl.innerHTML = `<span class="theme-money">$${formattedOriginalPrice}</span>`;
    
    console.log('[AbraBundle] Updated bundle price, fixed:', formattedBundlePrice, 'original:', formattedOriginalPrice);
  }
  async removeComponentFromBundle(variantIdToRemove, buttonEl) {
    console.log('[AbraBundle] Removing component:', variantIdToRemove);
    
    if (buttonEl) {
      buttonEl.disabled = true;
      buttonEl.classList.add('is-loading');
      buttonEl.innerHTML = '<span class="cart-item__bundle-component__loading-icon">⋯</span>';
    }
    
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const bundleItem = cart.items?.find(item => item.properties?._abra_bundle);
      if (!bundleItem) {
        console.error('[AbraBundle] Bundle not found in cart');
        return;
      }
      
      const bundleData = JSON.parse(bundleItem.properties._abra_bundle);
      const components = bundleData.components || [];
      
      const remainingComponents = components.filter(c => String(c.variantId) !== String(variantIdToRemove));
      
      console.log('[AbraBundle] Remaining components:', remainingComponents.length);
      
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: bundleItem.key, quantity: 0 })
      });
      
      console.log('[AbraBundle] Bundle removed');
      
      await new Promise(resolve => setTimeout(resolve, 300));
      
      for (const component of remainingComponents) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            id: parseInt(component.variantId), 
            quantity: component.quantity 
          })
        });
      }
      
      console.log('[AbraBundle] Remaining components added back to cart');
      
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      
    } catch (error) {
      console.error('[AbraBundle] Error removing component:', error);
      if (buttonEl) {
        buttonEl.disabled = false;
        buttonEl.classList.remove('is-loading');
        buttonEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';
      }
    }
  }
  async fetchComponentsData(components) {
    const variantIds = components.map(c => c.variantId);
    const results = [];
    const uncachedIds = [];

    for (const id of variantIds) {
      if (this.cache.has(id)) {
        results.push({ variantId: id, ...this.cache.get(id) });
      } else {
        uncachedIds.push(id);
      }
    }

    if (uncachedIds.length === 0) {
      return this.sortByOrder(results, variantIds);
    }

    const query = `
      query GetProductsByVariants($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
            title
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
            }
            product {
              title
              handle
              featuredImage {
                url(transform: { maxWidth: 40, maxHeight: 40 })
                altText
              }
            }
          }
        }
      }
    `;

    const graphqlIds = uncachedIds.map(id => `gid://shopify/ProductVariant/${id}`);

    try {
      const response = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.storefrontToken
        },
        body: JSON.stringify({
          query,
          variables: { ids: graphqlIds }
        })
      });

      const data = await response.json();
      
      if (data.errors) {
        throw new Error('GraphQL error: ' + JSON.stringify(data.errors));
      }

      const nodes = data.data?.nodes || [];
      
      for (const node of nodes) {
        if (node && node.id) {
          const variantId = node.id.split('/').pop();
          const productData = {
            title: node.product?.title || 'Unknown Product',
            variantTitle: node.title !== 'Default Title' ? node.title : null,
            handle: node.product?.handle || '',
            image: node.product?.featuredImage?.url || '',
            imageAlt: node.product?.featuredImage?.altText || '',
            price: parseFloat(node.price?.amount || 0) * 100,
            compareAtPrice: node.compareAtPrice ? parseFloat(node.compareAtPrice.amount) * 100 : null
          };
          console.log(productData);
          this.cache.set(variantId, productData);
          results.push({ variantId, ...productData });
        }
      }

      return this.sortByOrder(results, variantIds);
      
    } catch (error) {
      console.error('[AbraBundle] Error fetching components:', error);
      return variantIds.map(id => ({
        variantId: id,
        title: `Product ${id}`,
        handle: '',
        image: '',
        price: 0,
        compareAtPrice: null
      }));
    }
  }
  showBundleSkeleton() {
    console.log('[AbraBundle] ========== SHOW SKELETON ==========');
    
    const cartContainer = document.querySelector('cart-drawer') || document.querySelector('cart-form');
    if (!cartContainer) {
      console.warn('[AbraBundle] No cart container found');
      return;
    }

    const existingOverlay = cartContainer.querySelector('.cart-item__bundle-overlay');
    if (existingOverlay) {
      console.log('[AbraBundle] Overlay already exists, skipping');
      return;
    }

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const currentItemCount = cart.items?.length || 0;
        console.log('[AbraBundle] Current items:', currentItemCount, 'Last items:', this.lastItemCount);
        
        const hasBundle = cart.items?.some(item => item.properties?._abra_bundle);
        if (hasBundle) {
          console.log('[AbraBundle] Bundle already exists, not showing overlay');
          this.lastItemCount = currentItemCount;
          return;
        }

        if (currentItemCount <= this.lastItemCount) {
          console.log('[AbraBundle] Items not increased, skipping overlay');
          this.lastItemCount = currentItemCount;
          return;
        }

        if (currentItemCount < 4) {
          console.log('[AbraBundle] Not enough items (< 4), skipping overlay');
          this.lastItemCount = currentItemCount;
          return;
        }

        (async () => {
          const isEligible = await this.hasBundleEligibleItems();
          if (!isEligible) {
            console.log('[AbraBundle] Cart not eligible for bundle, skipping overlay');
            this.lastItemCount = currentItemCount;
            return;
          }
          
          console.log('[AbraBundle] All conditions met - showing overlay');
          this.lastItemCount = currentItemCount;
          
          const itemList = cartContainer.querySelector('.cart-item-list');
          if (!itemList) {
            console.error('[AbraBundle] Item list not found');
            return;
          }
          
          const overlay = document.createElement('div');
          overlay.className = 'cart-item__bundle-overlay';
          overlay.innerHTML = `
            <div class="cart-item__bundle-overlay__spinner"></div>
            <div class="cart-item__bundle-overlay__content">
              <div class="cart-item__bundle-overlay__title">🛠️ Creating your bundle...</div>
              <div class="cart-item__bundle-overlay__subtitle">Applying special discount</div>
            </div>
            <div class="cart-item__bundle-overlay__skeleton">
              <div class="cart-item__bundle-overlay__skeleton__header">
                <div class="cart-item__bundle-overlay__skeleton__image"></div>
                <div class="cart-item__bundle-overlay__skeleton__info">
                  <div class="cart-item__bundle-overlay__skeleton__title"></div>
                  <div class="cart-item__bundle-overlay__skeleton__subtitle"></div>
                </div>
              </div>
            </div>
          `;
          
          itemList.style.position = 'relative';
          itemList.appendChild(overlay);
          console.log('[AbraBundle] Overlay added to DOM');
          
          if (this.skeletonTimeout) {
            clearTimeout(this.skeletonTimeout);
          }
          this.skeletonTimeout = setTimeout(async () => {
            console.log('[AbraBundle] Timeout reached, checking if bundle created...');
            
            const cart = await fetch('/cart.js').then(r => r.json());
            const hasBundle = cart.items?.some(item => item.properties?._abra_bundle);
            
            if (hasBundle) {
              console.log('[AbraBundle] Bundle created, removing overlay');
              this.removeBundleSkeleton();
            } else {
              console.warn('[AbraBundle] Bundle not created after timeout');
              const overlay = document.querySelector('.cart-item__bundle-overlay');
              if (overlay) {
                overlay.innerHTML = `
                  <div class="cart-item__bundle-overlay__content">
                    <div class="cart-item__bundle-overlay__title">⚠️ Bundle discount unavailable</div>
                    <div class="cart-item__bundle-overlay__subtitle">Please try again or contact support</div>
                  </div>
                `;
                setTimeout(() => this.removeBundleSkeleton(), 5000);
              }
            }
          }, 15000);
        })();
      })
      .catch(error => {
        console.error('[AbraBundle] Error in showBundleSkeleton:', error);
      });
      
    console.log('[AbraBundle] ========== END SHOW SKELETON ==========');
  }
  removeBundleSkeleton() {
    console.log('[AbraBundle] Removing overlay...');
    
    if (this.skeletonTimeout) {
      clearTimeout(this.skeletonTimeout);
      this.skeletonTimeout = null;
    }
    
    const overlays = document.querySelectorAll('.cart-item__bundle-overlay');
    console.log('[AbraBundle] Found overlays:', overlays.length);
    
    overlays.forEach(overlay => {
      overlay.style.animation = 'overlay-fade-in 0.3s ease reverse';
      setTimeout(() => {
        overlay.remove();
        console.log('[AbraBundle] Overlay removed');
      }, 300);
    });
    
    const skeletons = document.querySelectorAll('.cart-item__bundle-skeleton');
    if (skeletons.length > 0) {
      console.log('[AbraBundle] Removing old skeletons:', skeletons.length);
      skeletons.forEach(el => el.remove());
    }
    
    if (overlays.length === 0 && skeletons.length === 0) {
      console.log('[AbraBundle] No overlay or skeleton found');
    }
  }
  sortByOrder(results, variantIds) {
    const orderMap = new Map(variantIds.map((id, index) => [id, index]));
    return results.sort((a, b) => {
      return (orderMap.get(a.variantId) || 0) - (orderMap.get(b.variantId) || 0);
    });
  }
  renderComponents(container, components) {
    if (components.length === 0) {
      container.innerHTML = '<div class="cart-item__bundle-variants__empty">No items in bundle</div>';
      return;
    }

    const html = components.map(component => {
      const displayTitle = component.variantTitle && component.variantTitle !== 'Default Title' 
        ? `${component.title} <span class="cart-item__bundle-variant-size">${component.variantTitle}</span>` 
        : component.title;
      
      return `
        <div class="cart-item__bundle-component">
          <div class="cart-item__bundle-component__image">
            ${component.image 
              ? `<img src="${component.image}" alt="${component.imageAlt || component.title}" loading="lazy">` 
              : '<div class="cart-item__bundle-component__no-image"></div>'}
          </div>
          <div class="cart-item__bundle-component__info">
            <div class="cart-item__bundle-component__title">
              <a href="/products/${component.handle}">${displayTitle}</a>
            </div>
          </div>
          <button class="cart-item__bundle-component__remove" data-remove-variant="${component.variantId}" title="Remove from bundle" aria-label="Remove from bundle">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </button>
        </div>
      `;
    }).join('');

    container.innerHTML = html;
    
    container.querySelectorAll('[data-remove-variant]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.getAttribute('data-remove-variant');
        this.removeComponentFromBundle(variantId, btn);
      });
    });
    
    console.log('[AbraBundle] Rendered successfully');
  }

}

let abraBundleLoader = null;
let initTimeout = null;

function initAbraBundles() {
  if (initTimeout) {
    clearTimeout(initTimeout);
  }
  
  initTimeout = setTimeout(() => {
    if (!abraBundleLoader) {
      abraBundleLoader = new AbraBundleLoader();
      window.abraBundleLoader = abraBundleLoader;
    }
    
    const bundles = document.querySelectorAll('[data-is-abra-bundle="true"]');
    if (bundles.length > 0) {
      console.log('[AbraBundle] Initializing, found', bundles.length, 'bundle(s)');
      abraBundleLoader.init();
    }
  }, 200);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAbraBundles);
} else {
  initAbraBundles();
}

document.addEventListener('cart:normalized', initAbraBundles);

document.addEventListener('cart:normalized', initAbraBundles);
document.addEventListener('on:cart:after-merge', () => {
  if (window.abraBundleLoader) window.abraBundleLoader.showBundleSkeleton();
  setTimeout(initAbraBundles, 300); // Увеличили задержку для надежности
});
document.addEventListener('abra:cart:changed', () => {
  setTimeout(initAbraBundles, 300);
});

